module.exports = __webpack_public_path__ + "assets/img/Logo-KIO.5b05aa56.png";